module.exports = __webpack_public_path__ + "gg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gg.svg
// module id = 563
// module chunks = 0